import { List, Record } from '@gonfalon/immutable-shim/immutableShim';

import { type TeamProjectReference } from './TeamProjectReference';

export class TeamProjectSummary extends Record<TeamProjectSummaryProps>({
  totalCount: 0,
  items: List(),
}) {}

type TeamProjectSummaryProps = {
  totalCount: number;
  items: List<TeamProjectReference>;
};

export const createTeamProjectSummary = (props: Partial<TeamProjectSummaryProps>): TeamProjectSummary =>
  props instanceof TeamProjectSummary ? props : new TeamProjectSummary(props);
